export default {
  113001: 'NOT_SUPPORTED_REGION',
  113002: 'FAIL_TO_INIT',
  113010: 'INVALID_WEB_TOKEN',
  113011: 'INVALID_GID',
  113012: 'INVALID_CONSOLE_LINK_PARAMETER',
  113013: 'INVALID_LOCAL_SESSION',
  113014: 'INVALID_LOCAL_PLATFORM',
  113015: 'NOT_DEFINED_WEB_TICKET',
  113101: 'FAIL_TO_GET_PLATFORM',
  113102: 'FAIL_TO_EXPIRE_WEBTOKEN',
  113103: 'FAIL_TO_VERIFY_WEBTOKEN',
  113104: 'FAIL_TO_GET_WEBTOKEN',
  113105: 'FAIL_TO_GET_WEBTOKEN_BY_GAMETOKEN',
  113106: 'FAIL_TO_GET_WEBTOKEN_BY_NPTOKEN',
  113107: 'FAIL_TO_GET_USER_PROFILE',
  113108: 'FAIL_TO_GET_WEBTICKET_BY_GAMETOKEN',
  113109: 'FAIL_TO_GET_WEBTICKET_BY_NPTOKEN',
  113110: 'FAIL_TO_GET_WEBTOKEN_BY_UNAUTHORIZED_WEBTICKET',
  113111: 'FAIL_TO_GET_WEBTOKEN_BY_WEBTICKET',
  113112: 'FAIL_TO_GET_WEBTOKEN_BY_WEBTICKET_FROM_GAME_TOKEN',
  113113: 'FAIL_TO_GET_WEBTOKEN_BY_INVALID_WEBTICKET',
  113114: 'FAIL_TO_GET_WEBTICKET_BY_GAMETOKEN_FOR_SSO_CORS',
  113122: 'FAIL_TO_EXPIRE_GUEST_WEBTOKEN',
  113123: 'FAIL_TO_VERIFY_GUEST_WEBTOKEN',
  113124: 'FAIL_TO_ISSUE_GUEST_WEBTOKEN_BY_WEBTICKET',
  113125: 'IAS_API_ERROR_FOR_GUEST_SESSION_INVALID_REQUEST',
  113201: 'FAIL_TO_GET_GID_SETTING',
  113202: 'FAIL_TO_GET_LINK_TICKET',
  113601: 'FAIL_TO_GET_TOY_MAINTENANCES',
}